import * as tslib_1 from "tslib";
import sortBy from 'lodash/sortBy';
import sum from 'lodash/sum';
import truncate from 'lodash/truncate';
var MAX_LABEL_SYMBOLS = 33;
var MAX_LEGEND_ITEMS_NUMBER = 30;
/**
 * returns all the data with dots "title..." labels if label if more then 25 symbols
 */

export var normalizeDataLabels = function normalizeDataLabels(data) {
  return data ? data.map(function (d) {
    return tslib_1.__assign({}, d, {
      title: truncate(d.title, {
        length: MAX_LABEL_SYMBOLS
      })
    });
  }) : data;
};
/**
 * all the items should be sorted from the greater value
 */

export var sortPieChartDataByValue = function sortPieChartDataByValue(data) {
  return !!data && data.length > 0 ? sortBy(data, function (_a) {
    var value = _a.value;
    return value;
  }).reverse() : data;
};

var splitAtIndex = function splitAtIndex(data, legendMaxItems) {
  return [data.slice(0, legendMaxItems), data.slice(legendMaxItems, data.length)];
};
/**
 * returns chart data, and if chart items more then 29, 30th item will be "Other" item
 */


export var getGroupedData = function getGroupedData(data) {
  if (data && data.length <= MAX_LEGEND_ITEMS_NUMBER) {
    return data;
  }

  var _a = tslib_1.__read(splitAtIndex(data, MAX_LEGEND_ITEMS_NUMBER - 1), 2),
      items = _a[0],
      others = _a[1];

  return tslib_1.__spread(items, [{
    title: 'Other',
    value: sum(others.map(function (d) {
      return d.value;
    }))
  }]);
};
/**
 *
 * @param {string} type
 * @param {am4charts.PieChart} chart
 * each metrics or dimensions in legend which don't exist in data should show in disable mode.
 */

export var disableZeroValues = function disableZeroValues(_a) {
  var type = _a.type,
      chart = _a.chart;

  if (chart.legend.enabled && chart.chartData.length > 0) {
    chart.chartData.forEach(function (entry) {
      return entry.value === 0 && chart.hideSlice(entry);
    });
  }
};